import * as React from "react"
import * as _ from "lodash"
import { CardModalNotOkButton } from "../../../../../modal"
import * as Model from "../../../../../../model"
import AttachAccountModalPresenter, { Names } from "./attach-account-modal-presenter"
import { NotificationProps } from "../../../../../notification"

class AttachAccountModal extends React.Component<AttachAccountModalProps, State> {
	constructor(props) {
		super(props)
		this.state = {
			newAccount: null,
			applyToLocalAuthorities: [],
			chapter: null,
		}
	}

	componentDidMount() {
		this.setState({ newAccount: this.state.newAccount, chapter: this.state.chapter})
	}

	render() {
		return <AttachAccountModalPresenter
		account={this.state.newAccount}
		accounts={this.props.accounts}
		chapter={this.state.chapter}
		chapters={this.props.chapters}
		notification={this.props.notification}
		loading={this.props.loading}
		loadingChapters={this.props.loadingChapters}
		onChange={e => this.handleChange(e)}
		onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
		onClickAttachAccountCloseButton={e => this.props.onClickAttachAccountModalCloseButton(e)}
		onClickFooterButton={(button, e) => this.handleClickFooterButton(button, e)}
		onSubmit={e => this.props.onSubmit(this.state.newAccount, this.state.chapter, e)} />
	}

	private handleClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void {
		this.props.onClickAttachAccountModalCloseButton(e)
	}

	private handleChange(e: React.SyntheticEvent<Element>) {
		let account: Model.Account = this.state.newAccount
		let chapter: Model.Chapter = this.state.chapter
		let laca: Model.LocalAuthorityChapterAccount = null
		const target = e.target as HTMLElement
		if (this.isHTMLInputElement(target)) {
			switch (target.name) {
				case Names.Expense:
					account.expense = target.checked
					break;
				case Names.Label:
					account.label = target.value
					break;
				case Names.Number:
					account.number = target.value
					break;
				case Names.Operation:
					account.operation = "1" === target.value
					break;
				case Names.Receipts:
					account.receipts = target.checked
					break;
			}
		} else if(this.isHTMLSelectElement(target)) {
			switch (target.name) {
				case Names.Account:
					account = this.props.accounts.find(acc => acc.id === parseInt(target.value))
					laca = this.props.lacas.find((lc) => lc.account.id === parseInt(target.value))
					chapter = laca && laca.chapter
					break;
				case Names.Chapter:
					chapter = this.props.chapters.find(ch => ch.id === parseInt(target.value))
					break;
			}
		}
		this.setState({ newAccount: account, chapter })
	}

	private isHTMLSelectElement(element: HTMLElement): element is HTMLSelectElement {
		return "SELECT" === element.tagName.toLocaleUpperCase()
	}

	private isHTMLInputElement(element: HTMLElement): element is HTMLInputElement {
		return "INPUT" === element.tagName.toLocaleUpperCase()
	}
}

export default AttachAccountModal

export interface AttachAccountModalProps {
	accounts: Model.Account[]
	chapters: Model.Chapter[]
	classes: Model.Class[]
	loading: boolean
	loadingChapters: boolean
	lacas: Model.LocalAuthorityChapterAccount[]
	notification: NotificationProps
	onClickAttachAccountModalCloseButton(e: React.SyntheticEvent<Element>): void
	onClickNotificationCloseButton(e: React.SyntheticEvent<Element>): void
	onSubmit(
		account: Model.Account,
		chapter: Model.Chapter,
		e: React.SyntheticEvent<Element>
	): void
}

interface State {
	newAccount: Model.Account
	applyToLocalAuthorities: Model.LocalAuthority[]
	chapter: Model.Chapter
}


// WEBPACK FOOTER //
// ./src/component/local-authority/local-authority-detail/instruction-card/instruction-list/attach-account-modal/index.tsx